import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IBoardingButton, IBoardingCheckList } from '../../interfaces/boarding-check-list';
import { BoardingCheckListService } from '../../services';
import { MenuService } from '../../services';
import { BBWTMessageService } from '../../services';
import { JobAlertService } from '../../services';

@Component({
  selector: 'boarding-check-list',
  templateUrl: './boarding-check-list.component.html',
})
export class BoardingCheckListComponent implements OnInit {
  public isBusy: boolean = false;
  public isShowBoardingCheckList: boolean = false;
  public boardingCheckList: IBoardingCheckList = null;
  public customerBoardingButtons: IBoardingButton[] = [];
  public supplierBoardingButtons: IBoardingButton[] = [];

  constructor(
    private boardingCheckListService: BoardingCheckListService,
    private router: Router,
    public messageService: BBWTMessageService,
    public jobAlertService: JobAlertService,
    private menuService: MenuService,
  ) {}

  ngOnInit() {
    this.boardingCheckListService
      .GetBoardingCheckList()
      .then((result) => {
        if (result) {
          this.isShowBoardingCheckList = true;
          this.boardingCheckList = result;
          this.FillButtons();
        }
      })
      .catch((ex) => {
        this.messageService.ShowError('Error', 'We were unable to download Boarding Check List');
      });
  }

  FillButtons() {
    this.customerBoardingButtons = [];
    this.supplierBoardingButtons = [];

    if (!this.boardingCheckList || !this.boardingCheckList.boardingButtons) {
      return;
    }

    this.boardingCheckList.boardingButtons.forEach((x) => {
      if (x.organisationTypeId == 2) {
        this.customerBoardingButtons.push(x);
      } else if (x.organisationTypeId == 3) {
        this.supplierBoardingButtons.push(x);
      }
    });
  }

  isAllValid() {
    var isAllValid = true;
    this.boardingCheckList.boardingButtons.forEach((x) => {
      if (x.isValid == false && x.isNeedValidate) {
        isAllValid = false;
      }
    });

    return isAllValid;
  }

  AnyIsOptional(buttons: IBoardingButton[], value: boolean): boolean {
    var result = false;

    buttons.forEach((x) => {
      if (x.isOptional == value) {
        result = true;
      }
    });

    return result;
  }

  HideThisScreen() {
    this.isBusy = true;
    this.boardingCheckListService
      .Hide()
      .then((result) => {
        this.isBusy = false;
        if (result) {
          this.boardingCheckList.isHide = true;
          this.messageService.ShowSuccess('Hide this screen', 'Settings successfully changed');

          this.jobAlertService
            .generateJobAlertSettings(this.boardingCheckList.organisationId)
            .then(() => {
              this.boardingCheckListService.changeBoardingCheckList.next(true);
            });
        } else {
          this.messageService.ShowWarning(
            'Hide this screen',
            'Change settings failed. Try restarting the page.',
          );
        }
      })
      .catch((ex) => {
        this.isBusy = false;
        this.messageService.ShowError(
          'Hide this screen',
          'Change settings failed. Try restarting the page. If this happens again, contact your administrator.',
        );
      });
  }

  GoTo(button: IBoardingButton) {
    if (!button) {
      return;
    }

    if (!button.isMarkAsUsed) {
      this.isBusy = true;
      this.boardingCheckListService
        .MarkAsUsed(button)
        .then((x) => {
          this.isBusy = false;
          button.isMarkAsUsed = true;
          this.GoToLink(button.link);
        })
        .catch((x) => {
          this.isBusy = false;
        });
    } else {
      this.GoToLink(button.link);
    }
  }

  GoToLink(link) {
    if (link && link != '') {
      this.router.navigate(['app/' + link, { backTo: this.router.url }]);
    }
  }
}
